module.exports = __webpack_public_path__ + "img/news22-0.a1f1c79b.jpg";